<template>
  <div>
    <custom-header></custom-header>
    <section class="content">
      <div class="columns">
        <div class="column">
          <h1>Batches</h1>
          <batch-table :url="url" :type="$route.query.type"></batch-table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
const url = "https://api.business.biya.com.ng/api/v1";
import CustomHeader from '@/components/CustomHeader'
import BatchTable from '@/components/dothraki/BatchTable'

export default {
  data() {
    return {
      messageClass: 'is-loading',
      message: '',
      spinnerShow: true,
      tableData: null,
      url: url + '/admin/batch/' + this.$route.params.id,
    }
  },
  components: {
    CustomHeader, BatchTable
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.spinner {
  margin: 100px auto;
  width: 40px;
  height: 40px;
  position: relative;
  text-align: center;
  -webkit-animation: sk-rotate 2.0s infinite linear;
  animation: sk-rotate 2.0s infinite linear;
}

.dot1,
.dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #0ac97b;
  border-radius: 100%;

  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.dot2 {
  top: auto;
  bottom: 0;
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-rotate {
  100% {
    -webkit-transform: rotate(360deg)
  }
}

@keyframes sk-rotate {
  100% {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg)
  }
}

@-webkit-keyframes sk-bounce {
  0%,
  100% {
    -webkit-transform: scale(0.0)
  }
  50% {
    -webkit-transform: scale(1.0)
  }
}

@keyframes sk-bounce {
  0%,
  100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  }
  50% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}
</style>



// WEBPACK FOOTER //
// Batch.vue?285db1f8